/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Tasks_Cancel_In_ProgressInputs */

const en_tasks_cancel_in_progress = /** @type {(inputs: Tasks_Cancel_In_ProgressInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Cancelling…`)
};

const fr_tasks_cancel_in_progress = /** @type {(inputs: Tasks_Cancel_In_ProgressInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Annulation…`)
};

const ms_sg2_tasks_cancel_in_progress = /** @type {(inputs: Tasks_Cancel_In_ProgressInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Membatalkan…`)
};

/**
* | output |
* | --- |
* | "Cancelling…" |
*
* @param {Tasks_Cancel_In_ProgressInputs} inputs
* @param {{ locale?: "en" | "fr" | "ms-SG" }} options
* @returns {LocalizedString}
*/
export const tasks_cancel_in_progress = /** @type {((inputs?: Tasks_Cancel_In_ProgressInputs, options?: { locale?: "en" | "fr" | "ms-SG" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Tasks_Cancel_In_ProgressInputs, { locale?: "en" | "fr" | "ms-SG" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_tasks_cancel_in_progress(inputs)
	if (locale === "fr") return fr_tasks_cancel_in_progress(inputs)
	return ms_sg2_tasks_cancel_in_progress(inputs)
});